import React, { createContext, useContext, useState, useCallback } from 'react';
import PropTypes from 'prop-types';

const BookmarkRefreshContext = createContext();

export const useBookmarkRefresh = () => {
    const context = useContext(BookmarkRefreshContext);
    if (!context) {
        throw new Error(
            'useBookmarkRefresh must be used within BookmarkRefreshProvider'
        );
    }
    return context;
};

export const BookmarkRefreshProvider = ({ children }) => {
    const [refreshCallback, setRefreshCallback] = useState(null);

    const registerRefresh = useCallback(callback => {
        setRefreshCallback(() => callback);
    }, []);

    const unregisterRefresh = useCallback(() => {
        setRefreshCallback(null);
    }, []);

    const triggerRefresh = useCallback(() => {
        if (refreshCallback) {
            refreshCallback();
        }
    }, [refreshCallback]);

    return (
        <BookmarkRefreshContext.Provider
            value={{ registerRefresh, unregisterRefresh, triggerRefresh }}
        >
            {children}
        </BookmarkRefreshContext.Provider>
    );
};

BookmarkRefreshProvider.propTypes = {
    children: PropTypes.node.isRequired,
};
